import { ChangeEvent, MouseEventHandler } from "react";
import { SelectedEntityWithException } from "~/components/exceptions/types";
import { SelectedEntity } from "~/hooks/useSelection";
import {
  CaseStatus,
  ExceptionMutationAction,
  ExceptionStatus,
  GetAffectedAssetsQuery,
  Icon_Ids,
  Scalars,
  ScoreRating,
  ScoreState,
  Tag,
  TicketRefType,
} from "~/operations";
import { SelectedEntityWithFindingData } from "~/components/exceptions/SetExceptionDialog";
import { RiskFactorsIconsProps } from "~/pages/space/security/components/RiskFactors/RiskFactorsIcons";

export type ExposedAssetsFindings = Extract<
  GetAffectedAssetsQuery["findings"],
  { __typename: "FindingsConnection" }
>;
export type ExposedAssetsEdges = NonNullable<ExposedAssetsFindings["edges"]>;
export type ExposedAssetsEdge = ExposedAssetsEdges[0];
export type ExposedAssetsNode = NonNullable<ExposedAssetsEdge["node"]>;
export type ExposedAssetsAdvisoryNode = Extract<
  ExposedAssetsNode,
  { __typename: "AdvisoryFinding" }
>;
export type ExposedAssetsCVENode = Extract<
  ExposedAssetsNode,
  { __typename: "CveFinding" }
>;

export type SelectedAssets = Array<
  SelectedEntityWithExposedAssetData &
    SelectedEntityWithException &
    SelectedEntityWithFindingData
>;
export type SelectionProps = {
  selectedEntities: SelectedAssets;
  hasSelectPermissions: boolean;
  onCheckboxClick: MouseEventHandler;
  onCheckboxChange: (
    e: ChangeEvent<HTMLInputElement>,
    checked: boolean,
    data: ExposedAsset,
  ) => {};
  onCheckAll: (
    checked: boolean,
    edges: Array<{ mrn: string }> | null | undefined,
  ) => void;
  getIsRowSelected: (identifier: string) => boolean;
  onCancel: () => void;
};

export const AssetContextualLinkType = {
  Check: "Check",
  Cve: "Cve",
  Advisory: "Advisory",
  Software: "Software",
  Asset: "Asset",
};

export type SelectedEntityWithExposedAssetData = SelectedEntity & {
  scopeMrn: string;
  findingMrn: string;
};
export type ExposedAsset = {
  __typename: string;
  isAffectedAsset: boolean;
  score: number;
  lastUpdated: string;
  riskFactors: RiskFactorsIconsProps["riskFactors"];
  title?: string;
  tags?: (Tag | null)[] | null | undefined;
  iconId?: Icon_Ids | null;
  id: string;
  mrn: string;
  assetMrn: string;
  rating: ScoreRating;
  cases?: {
    __typename: "CasesConnection";
    totalCount: number;
    edges?: Array<{
      __typename: "CaseEdge";
      node: {
        __typename: "Case";
        status: CaseStatus;
        mrn: string;
        createdAt: string;
        ticketRefs?: Array<{
          __typename: "TicketRef";
          type: TicketRefType;
        }> | null;
      };
    }> | null;
  } | null;
  exception?:
    | {
        id: string;
        action: ExceptionMutationAction;
        exceptionId: Scalars["String"]["output"];
        status: ExceptionStatus;
        createdAt: Scalars["String"]["output"];
      }
    | null
    | undefined;
  state?: ScoreState;
  spaceRiskDelta?:
    | null
    | undefined
    | {
        delta: number;
        effort: number;
        manualEffort: {
          research: number;
          rollout: number;
          scripting: number;
          totalManualEffort: number;
          verification: number;
        };
      };
};
